export default "__VITE_ASSET__6614a0f1__"